import Checkbox from "./Checkbox"
import Radio from "./Radio"
import Input from "./Input"
import Select from "./Select"
import Textarea from "./Textarea"
import Date from "./Date"
import File from "./File"
import SelectSearch from "./SelectSearch/SelectSearch.vue"
const useInputs = () => {
  return { Checkbox, Radio, Input, Select, Textarea, Date, File, SelectSearch };
};

export default useInputs;